export default __webpack_public_path__ + "static/media/Airport.4309e3e9.svg";